import { asyncRoutes, constantRoutes } from '@/router';
import { VuexModule, Module, MutationAction, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { RoleInfo } from '@/api/userCenter';
import { RouteConfig } from 'vue-router';
import path from 'path';

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes: RouteConfig[], prmissions: Set<String>, basePath = '/', height = 1) {
  const res: RouteConfig[] = [];
  routes.forEach((route) => {
    const tmp = { ...route };
    const pathTo = path.resolve(basePath, tmp.path);

    if (tmp.children) {
      tmp.children = filterAsyncRoutes(tmp.children, prmissions, pathTo, height + 1);
      if (!!tmp.children && tmp.children.length > 0) {
        res.push(tmp);
      }
    } else {
      if (prmissions.has(pathTo)) {
        res.push(tmp);
      }
    }
  });

  return res;
}

export interface IPermissionState {
  routes: RouteConfig[];
  addRoutes: RouteConfig[];
}

@Module({ dynamic: true, store, name: 'permission' })
class Permission extends VuexModule implements IPermissionState {
  public routes: RouteConfig[] = [];
  public addRoutes: RouteConfig[] = [];

  @Action({ commit: 'SET_ROUTES' })
  public async GenerateRoutes(data: RoleInfo) {
    // 先构建一个set, 加快判断
    const prmissions: Set<string> = new Set();
    for (const iterator of data.frontPermissions.permissions) {
      prmissions.add(iterator.path);
    }
    let accessedRoutes: RouteConfig[];
    if (data.root) {
      accessedRoutes = asyncRoutes;
    } else {
      accessedRoutes = filterAsyncRoutes(asyncRoutes, prmissions);
      let i = 0;
    }
    return accessedRoutes;
  }

  @Mutation
  private SET_ROUTES(routes: RouteConfig[]) {
    this.addRoutes = routes;
    this.routes = constantRoutes.concat(routes);
  }
}
export const PermissionModule = getModule(Permission);
